import React from 'react';
import { Formik } from 'formik';
import { IVisitorSearchStepProps, IVisitorSearchResult } from './types';
import VisitorSearchForm from './VisitorSearchForm';
import useStepper from '../../../stepper/useStepper';
import findByEmailAddress from './findByEmailAddress';
import schema from './schema';
import { IApiError } from '../../../../services';

const VisitorSearchStep: React.FC<IVisitorSearchStepProps> = ({
  initialValues,
  onSubmit,
  onError,
}) => {
  const { showNext } = useStepper();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={(values) => {
        let details: IVisitorSearchResult = {
          visitorTypeId: null,
          surname: '',
          firstNames: '',
          company: '',
          carRegistration: '',
          emailAddress: values.emailAddress ?? '',
          mobile: '',
          host: '',
        };

        if (values.emailAddress) {
          findByEmailAddress(values.emailAddress)
            .then((response) => {
              const { success, result } = response.data;

              if (success) {
                details = { ...details, ...result };
              }

              onSubmit(details);
              showNext();
            })
            .catch((error: IApiError) => {
              onError(error.messages);
            });
        } else {
          onSubmit(details);
          showNext();
        }
      }}
    >
      <VisitorSearchForm />
    </Formik>
  );
};

export default VisitorSearchStep;
